import historyActions from './history/actions';
import cacheActions from './cache/actions';
import cookieActions from './cookies/actions';

export default {
  ...historyActions,
  ...cacheActions,
  ...cookieActions
};
